var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineArrowLeft = function SvgLineArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "line-arrow-left_svg__Lager_1",
    "data-name": "Lager 1",
    viewBox: "0 0 21.6 18.83"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".line-arrow-left_svg__cls-1{fill:none;stroke:#1e2022;stroke-linecap:square;stroke-width:2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.41 1.41-8 8 8 8M20.6 9.56H3.29",
    className: "line-arrow-left_svg__cls-1"
  })));
};
export default SvgLineArrowLeft;